export class AuMapConstructClass {
	public itemMap = new Map<string, any>();

	constructor(private array: { key: string; value: string }[]) {
		for (const item of this.array) {
			this.itemMap.set(item.key, item.value);
		}
	}
}
